import React from 'react'

//
import CareersBodySection from '../CareersBodySection'

const CareersBody = ({ sections = [] }) => (
  <section className="l-section">
    <div className="l-container:8/12 l-container--default-spacing">
      {sections?.map((section, idx) => (
        <React.Fragment key={`job-desc-${idx}`}>
          <CareersBodySection title={section?.heading} body={section?.body} />
          {idx < sections?.length - 1 ? <hr className="c-careers__divider" /> : null}
        </React.Fragment>
      ))}
    </div>
  </section>
)

export default CareersBody
